//
import React from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { platform } from 'app-components/utils/core';

import { isPushNotificationsWaitingPermissions } from 'swPushNotifications';

import InstallViaAddToHomeScreen from './InstallViaAddToHomeScreen';
import InstallViaInstallPrompt from './InstallViaInstallPrompt';
import PushNotificationPrompt from './PushNotificationsPrompt';
import { shouldUserBePromptedForPushNotifications, shouldUserBePromptedToInstall, trackUse } from './PwaHelpers';

const renderInstallPrompt = () => {
  if (platform.isPwaInstalled || !(platform.supportsOnBeforeInstallPrompt || platform.supportsManualAddToHomeScreen)) {
    return null;
  }

  if (!shouldUserBePromptedToInstall()) {
    return null;
  }

  if (platform.supportsOnBeforeInstallPrompt) {
    return <InstallViaInstallPrompt />;
  }

  if (platform.supportsManualAddToHomeScreen) {
    return <InstallViaAddToHomeScreen />;
  }

  return null;
};

const renderPushNotificationsPrompt = () => {
  if (
    !platform.supportsPushNotifications ||
    !isPushNotificationsWaitingPermissions() ||
    !shouldUserBePromptedForPushNotifications()
  ) {
    return null;
  }

  return <PushNotificationPrompt />;
};

const ShowPwaPrompts = () => {
  trackUse();

  const serviceWorkerEnableInstall = useSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'serviceWorkerEnableInstall'),
  );
  const serviceWorkerEnablePushNotifications = useSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'serviceWorkerEnablePushNotifications'),
  );

  return (
    <>
      {serviceWorkerEnableInstall && renderInstallPrompt()}
      {serviceWorkerEnablePushNotifications && renderPushNotificationsPrompt()}
    </>
  );
};

export default React.memo(ShowPwaPrompts);
